module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }